// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди)
// Поле составного типа 1С (бэк datahub: is_multi_type, attr_type AttrLink, relation_segments [...], relation_segment НЕТ — он ставится только при одном
// типе): значение — id записи ОДНОГО из сегментов. Резолв — по сегментам ПО ОЧЕРЕДИ: первый сегмент, в словаре которого id найден, даёт название и
// сегмент открытия записи; не найден ни в одном — сырой id, как у одиночной ссылки без названия. Запросы — штатный store.get_itemsSource(by_ids)
// (50-мс очередь, дедуп _pending_ids, negative-cache _missing_ids / _title_miss); следующий сегмент спрашивается, только когда предыдущий ответил
// «нет такого id». Ответ без новых id не будит вотчеры (waveGuard R9) — поэтому mainStore зовёт mtl_answered после каждого ответа словаря,
// подписчики (AttrLink / AttrGrid) пересчитывают выбор. Кэш id → {segment, title} — на сеанс; кэш, подписки и сбойные запросы — в WeakMap модуля
// по стору (не в состоянии Pinia: без реактивности и без следов в сторе). Выключатель fe.ux.multiTypeLinks
// (по умолчанию вкл.; выкл. — прежнее поведение: поле без relation_segment рисуется пустым). Счётчики — window._mtlStats.

export const MTL_FLAG = 'fe.ux.multiTypeLinks'
const SEP = '\u0001'

// id ссылки: непустая строка без пробелов, не выражение ('=…'), не маркер ('#…'), не JSON
export function mtl_isId(v) {
    return typeof v === 'string' && v.length > 0 && v.length <= 200 && !/\s/.test(v)
        && !v.startsWith('=') && !v.startsWith('#') && !v.startsWith('{')
}

// выключатель: store.setting — действие Pinia, а отрисовка ячеек зовёт проверку на каждую ячейку — значение держится 1 с
let _flag = { store: null, t: 0, v: true }
export function mtl_on(store) {
    if (!store || typeof store.setting !== 'function') return true
    const now = Date.now()
    const key = mtl_storeKey(store)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048c
    if (_flag.store === key && now - _flag.t < 1000) return _flag.v
    let v = true
    try { v = store.setting(MTL_FLAG, true) !== false } catch (e) { v = true }
    _flag = { store: key, t: now, v }
    return v
}
export function mtl_flagReset() { _flag = { store: null, t: 0, v: true } }   // тесты / живое переключение без ожидания

// сегменты поля составного типа: массив (без дублей, в исходном порядке) или null — поле не составное / выключено.
// Мемо по объекту attr: одна и та же ссылка на массив, пока attr.relation_segments не заменён
const _segsMemo = new WeakMap()
export function mtl_segments(attr, store = null) {
    if (!attr || typeof attr !== 'object') return null
    if (attr.attr_type !== 'AttrLink' || attr.relation_segment || attr.relation_segment_binding) return null
    const list = attr.relation_segments
    if (!Array.isArray(list) || !list.length) return null
    let m = _segsMemo.get(attr)
    if (!m || m.src !== list || m.len !== list.length) {
        const segs = []
        for (const s of list) if (typeof s === 'string' && s && !s.startsWith('=') && !s.startsWith('{') && !segs.includes(s)) segs.push(s)
        m = { src: list, len: list.length, segs: segs.length ? segs : null }
        _segsMemo.set(attr, m)
    }
    if (!m.segs) return null
    if (store && !mtl_on(store)) return null
    return m.segs
}

// состояние id в словаре сегмента (store.itemsSource[segment]):
// 'found' — есть; 'missing' — сегмент ответил «нет» (negative-cache, промах, ошибка запроса, загружен весь список); 'pending' — запрошен, ждём;
// 'unknown' — ещё не спрашивали
export function mtl_idState(IS, id, failed = null, segment = '') {
    if (failed && failed.has(segment + SEP + id)) return IS?.ids?.[id] ? 'found' : 'missing'
    if (!IS) return 'unknown'
    if (IS.ids && IS.ids[id]) return 'found'
    if (IS._missing_ids && IS._missing_ids.has(id)) return 'missing'
    if (IS._title_miss && IS._title_miss[id] > 0) return 'missing'
    if (IS._pending_fetchMode === 'all') return Array.isArray(IS.data) ? 'missing' : 'pending'
    if (IS._pending_ids && IS._pending_ids.has(id)) return 'pending'
    return 'unknown'
}

// выбор сегмента по очереди: первый 'found' — он; 'missing' — к следующему; 'pending' — ждать ответа этого сегмента; 'unknown' — спросить его
// → { state: 'found' | 'wait' | 'request' | 'missing', segment, item }
export function mtl_pick(segments, id, getIS, failed = null) {
    for (const seg of segments || []) {
        const IS = getIS(seg)
        const st = mtl_idState(IS, id, failed, seg)
        if (st === 'found') return { state: 'found', segment: seg, item: IS.ids[id] }
        if (st === 'missing') continue
        return { state: st === 'pending' ? 'wait' : 'request', segment: seg, item: null }
    }
    return { state: 'missing', segment: '', item: null }
}

export function mtl_stats() {
    const g = typeof window !== 'undefined' ? window : globalThis
    if (!g._mtlStats) g._mtlStats = { resolve: 0, cacheHits: 0, requests: 0, requestIds: 0, found: 0, answers: 0, failed: 0 }
    return g._mtlStats
}

const _cacheBy = new WeakMap(), _hooksBy = new WeakMap(), _failedBy = new WeakMap()
// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048c: ключ — СЫРОЙ объект стора. В dev-сборке плагин devtools Pinia
// (patchActionForGrouping, опции-стор) зовёт каждое действие с this = new Proxy(store) — новый прокси на каждый вызов: подписка по
// window._store / this.store и вызов mtl_answered(store) из async_get_itemsSource_data расходились (замер p048c_diag на dev02: ключ — прокси,
// key !== store, key.__v_raw === store.__v_raw). __v_raw у реактивного (и у прокси над ним) — сырой объект; у простого объекта — нет (он сам)
export function mtl_storeKey(store) {
    if (!store || typeof store !== 'object') return store
    let raw
    try { raw = store.__v_raw } catch (e) { raw = undefined }
    return (raw && typeof raw === 'object') ? raw : store
}
function bag(map, store, make) {
    const key = mtl_storeKey(store)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048c
    let v = map.get(key)
    if (!v) { v = make(); map.set(key, v) }
    return v
}
const cacheOf = (store) => bag(_cacheBy, store, () => new Map())
// префикс ключа кэша по массиву сегментов (мемо: отрисовка ячеек зовёт резолв на каждую ячейку — без склейки строки каждый раз)
const _keyBy = new WeakMap()
function keyOf(segments) {
    let k = _keyBy.get(segments)
    if (k === undefined) { k = segments.join('|') + SEP; _keyBy.set(segments, k) }
    return k
}
export function mtl_cache(store) { return store && typeof store === 'object' ? cacheOf(store) : null }   // пробы / тесты

// запрос id в словарь сегмента — штатной очередью (vueObj — только WIDGET: get_itemsSource пишет vueObj.itemsSource у AttrLink)
export function mtl_request(store, segment, ids, vueObj = null) {
    const list = [...new Set((ids || []).filter(mtl_isId))]
    if (!segment || !list.length || typeof store?.get_itemsSource !== 'function') return
    const S = mtl_stats()
    S.requests++; S.requestIds += list.length
    try {
        store.get_itemsSource({ WIDGET: vueObj?.WIDGET }, {}, { attr_type: 'AttrLink', relation_segment: segment }, { fetchMode: 'by_ids', ids: list })
    } catch (e) { /* словарь недоступен — останется сырой id */ }
}

// резолв одного id → { state: 'none' | 'found' | 'wait' | 'request' | 'missing', segment, item, title }
// opts.request === false — без запроса (пачка собирает их сама)
export function mtl_resolve(store, segments, id, vueObj = null, opts = null) {
    if (!mtl_isId(id) || !Array.isArray(segments) || !segments.length || !store) return { state: 'none', segment: '', item: null, title: '' }
    const S = mtl_stats()
    S.resolve++
    const cache = cacheOf(store)
    const key = keyOf(segments) + id
    const hit = cache.get(key)
    if (hit) {
        S.cacheHits++
        const live = store.itemsSource?.[hit.segment]?.ids?.[id]
        return { state: 'found', segment: hit.segment, item: live || hit, title: (live && live.title) || hit.title || id }
    }
    const r = mtl_pick(segments, id, seg => store.itemsSource?.[seg], _failedBy.get(mtl_storeKey(store)) || null)   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048c
    if (r.state === 'found') {
        const title = r.item?.title || ''
        cache.set(key, { segment: r.segment, title })
        S.found++
        r.title = title || id
    } else {
        r.title = id
        if (r.state === 'request' && opts?.request !== false) mtl_request(store, r.segment, [id], vueObj)
    }
    return r
}

// пачка id одной колонки: по одному запросу на сегмент (только id, чья очередь дошла до этого сегмента)
export function mtl_resolveMany(store, segments, ids, vueObj = null) {
    const out = { found: 0, wait: 0, request: 0, missing: 0 }
    const bySeg = {}
    for (const id of new Set(ids || [])) {
        if (!mtl_isId(id)) continue
        const r = mtl_resolve(store, segments, id, vueObj, { request: false })
        if (r.state in out) out[r.state]++
        if (r.state === 'request') (bySeg[r.segment] = bySeg[r.segment] || []).push(id)
    }
    for (const seg in bySeg) mtl_request(store, seg, bySeg[seg], vueObj)
    return out
}

// сегмент открытия записи по уже резолвленному id ('' — не найден / не составное поле); без запросов
export function mtl_segmentOf(store, attr, id) {
    const segs = mtl_segments(attr, store)
    if (!segs || !mtl_isId(id)) return ''
    const r = mtl_resolve(store, segs, id, null, { request: false })
    return r.state === 'found' ? r.segment : ''
}

// ответ словаря сегмента (зовёт mainStore.async_get_itemsSource_data: ok — ответ пришёл, !ok — ошибка / ответ без data):
// при ошибке id сегмента считаются «нет» (иначе они навсегда остаются в _pending_ids и очередь сегментов встаёт); подписчики пересчитывают выбор
export function mtl_answered(store, segment, ids, ok) {
    const hooks = store && typeof store === 'object' ? _hooksBy.get(mtl_storeKey(store)) : null   // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048c
    if (!hooks || !hooks.size) return
    const S = mtl_stats()
    S.answers++
    if (!ok && Array.isArray(ids)) {
        const failed = bag(_failedBy, store, () => new Set())
        for (const id of ids) failed.add(segment + SEP + id)
        S.failed += ids.length
    }
    for (const fn of [...hooks]) {
        try { fn(segment, ids, ok) } catch (e) { /* подписчик */ }
    }
}

// подписка на ответы словарей; возвращает отписку
export function mtl_subscribe(store, fn) {
    if (!store || typeof store !== 'object' || typeof fn !== 'function') return () => {}
    const hooks = bag(_hooksBy, store, () => new Set())
    hooks.add(fn)
    return () => { hooks.delete(fn) }
}

// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048b:
// строка-поле формы записи (widget-record = AttrGrid AttrTabGrid, одна строка — одно поле; V — копия описания поля, store.prepare_AttrMulti).
// Найден — V.valueStr = название, V._mtlSeg = сегмент (стрелка и открытие записи); ждём — сырой id без пометки; нигде нет — сырой id,
// V._mtlState = 'missing' (prepare_AttrMulti ставит is_customValueWarning, как у одиночной ссылки без названия). Служебные признаки —
// НЕперечислимые: V копируется спредом ({...dataItem.attr}) и не должен нести их в записи / формы настроек. vueObj.mtl_formWatch(segs) —
// грид подписывается на ответы словарей и пересобирает строки (пустой ответ вотчер не будит)
function hidden(obj, key, value) {
    try { Object.defineProperty(obj, key, { value, enumerable: false, configurable: true, writable: true }) } catch (e) { /* замороженный объект */ }
}
export function mtl_valueMulti(store, V, segs, vueObj = null) {
    if (!V || typeof V !== 'object') return false
    const r = mtl_resolve(store, segs, V.value, vueObj)
    hidden(V, '_mtlSeg', r.state === 'found' ? r.segment : '')
    hidden(V, '_mtlState', r.state)
    try { if (vueObj && typeof vueObj.mtl_formWatch === 'function' && r.state !== 'none') vueObj.mtl_formWatch(segs) } catch (e) { /* грид без подписки */ }
    if (r.state === 'found') {
        V.valueStr = r.title
        hidden(V, '_mtlTitleFor', V.value)
        return true
    }
    if (V.value != null && V.value !== '' && (!V.valueStr || (V._mtlTitleFor !== undefined && V._mtlTitleFor !== V.value))) {
        V.valueStr = String(V.value)   // сырой id — как у одиночной ссылки без названия
        hidden(V, '_mtlTitleFor', undefined)
    }
    return false
}

// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106001: AttrLink составного типа 1С — резолв по relation_segments по очереди) · p048d:
// пометка «не найден ни в одном сегменте» (is_customValueWarning) у строки-поля составного типа снимается ТОЛЬКО найденным значением.
// store.prepare_AttrMulti при !founded и уже стоящей пометке уходил в ветку «снять» — повторная пересборка строк (ответ словаря,
// prepare_AttrMulti_all) переключала флаг: класс custom-value-warning мигал 1–2 с и пропадал (проба p048c на dev02). true — оставить пометку
export function mtl_keepWarning(V, founded) {
    if (!V || typeof V !== 'object' || founded || !V.is_customValueWarning) return false
    const st = V._mtlState
    return st === 'missing' || st === 'wait' || st === 'request'
}
